<template>
  <v-dialog :value="value" max-width="460" @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="text-h6">{{ $t("print_layout_title") }}</v-card-title>
      <v-card-text class="pb-2">
        <v-btn
          block
          outlined
          color="primary"
          class="print-layout-option mb-3"
          @click="choose(true)"
        >
          <v-icon left>mdi-file-multiple-outline</v-icon>
          <span class="print-layout-option__text">
            <b>{{ $t("print_layout_separate") }}</b>
            <small>{{ $t("print_layout_separate_hint") }}</small>
          </span>
        </v-btn>
        <v-btn block outlined color="primary" class="print-layout-option" @click="choose(false)">
          <v-icon left>mdi-file-document-outline</v-icon>
          <span class="print-layout-option__text">
            <b>{{ $t("print_layout_same") }}</b>
            <small>{{ $t("print_layout_same_hint") }}</small>
          </span>
        </v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">{{ $t("cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Izbor rasporeda štampe kad izveštaj ima više firmi: svaka firma na posebnom listu ili sve jedna ispod druge
 * na istom listu (za male firme sa 2–3 radnika). Emituje `choose` sa `true` kad je izabran poseban list.
 */
export default {
  name: "PrintLayoutDialog",
  props: {
    value: { type: Boolean, default: false },
  },
  methods: {
    choose(separatePages) {
      this.$emit("input", false);
      this.$emit("choose", separatePages);
    },
  },
};
</script>

<style scoped>
.print-layout-option {
  height: auto !important;
  min-height: 64px;
  padding: 10px 16px !important;
  justify-content: flex-start;
  text-transform: none;
  letter-spacing: normal;
}

.print-layout-option__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  white-space: normal;
}

.print-layout-option__text small {
  font-weight: 400;
  opacity: 0.75;
}
</style>
